console.clear();

// DOM Selection:
const svg = document.querySelector('svg');
const hardwareBody = document.querySelector('.hardware-body');
console.log(hardwareBody);
const emitter = document.querySelector('.emitter')
// const emitterX = emitter.getBBox().x;
const emitterX = emitter.getBBox().x + Number(emitter.clientWidth/2) + 10
// const emitterY = emitter.getBBox().y;
const emitterY = emitter.getBBox().y + (emitter.clientHeight/2) + 10;
console.log(emitterX, emitterY);

const particlesParent = document.querySelector('#particles');

// const particlesPerCycle = 6;
// const particleSize = 1;
// const particleSizeRandom = 5;
// const particleSpeed = 8;
// const particleSpeedRandom = 3;
// const emissionDirection = -270;
// const emissionDirectionRandom = 1;
// const emitterRadius = 5;
// const gravityDirection = 0;
// const gravitySpeed = 9;
// const dragMultiplier = 0.9;

const particlesPerCycle = 3;
const particleSize = 1;
const particleSizeRandom = 5;
const particleSpeed = 8.4*2;
// const particleSpeedRandom = 3.5;
const particleSpeedRandom = 6.5;
const emissionDirection = -255;
const emissionDirectionRandom = 1;
// const emitterRadius = 5;
const emitterRadius = 10;
const gravityDirection = 0;
const gravitySpeed = 1.5*2;
// const dragMultiplier = 0.9;
const dragMultiplier = 0.8;


var svgNS = "http://www.w3.org/2000/svg";
// var s = document.getElementById('root');
var config = {};

// UTILITY FUNCTION
function vaguely(number, vagueness) {
    return((Math.random() * Number(vagueness)) - Number(vagueness) / 2) + Number(number);
}
function degToRadians(degrees) {
    return(Math.PI / 180) * degrees;
}
function calculateVector(strength, direction) {
    var _radians = degToRadians(direction);
    return [
        Math.cos(_radians) * strength,
        Math.sin(_radians) * strength
    ];
}

function doSetup() {
    // config.height = hardwareBody.getBBox().x;
    // config.width = hardwareBody.clientHeight;
    config.height = 1000;
    config.width = 600;
    config.emitterCentre = [emitterX, emitterY];
}
doSetup();
console.log(config)
function createSvgCircle(cx, cy, r, fill, stroke, parent) {
    var c = document.createElementNS(svgNS, 'circle');
    c.setAttribute("class", "particle");
    c.setAttributeNS(null, 'r', Math.max(0, r));
    c.setAttributeNS(null, 'cx', cx);
    c.setAttributeNS(null, 'cy', cy);
    c.setAttributeNS(null, 'fill', fill);
    c.setAttributeNS(null, 'data-velocity', vaguely(particleSpeed, particleSpeedRandom));
    c.setAttributeNS(null, 'data-direction', vaguely(emissionDirection, emissionDirectionRandom));
    if (stroke) {
        c.setAttributeNS(null, 'stroke', stroke);
    }
    parent.appendChild(c);
}
function applyGravity(gravityStrength, gravityDirection) {
    var _particles = Array.prototype.slice.call(document.querySelectorAll('.particle'));
    var _vector = calculateVector(gravityStrength, gravityDirection);
    _particles.forEach(function (element, index, array) {
        var startCx = Number(element.getAttributeNS(null, 'cx'));
        var startCy = Number(element.getAttributeNS(null, 'cy'));
        var endCx = startCx + _vector[0];
        var endCy = startCy + _vector[1];
        element.setAttributeNS(null, 'cx', endCx);
        element.setAttributeNS(null, 'cy', endCy);
    });
}
function applyVelocity() {
    var _particles = Array.prototype.slice.call(document.querySelectorAll('.particle'));
    _particles.forEach(function (element, index, array) {
        var _vector = calculateVector(element.getAttributeNS(null, 'data-velocity'), element.getAttributeNS(null, 'data-direction'));
        var startCx = Number(element.getAttributeNS(null, 'cx'));
        var startCy = Number(element.getAttributeNS(null, 'cy'));
        var endCx = startCx + _vector[0];
        var endCy = startCy + _vector[1];
        element.setAttributeNS(null, 'cx', endCx);
        element.setAttributeNS(null, 'cy', endCy);
        element.setAttributeNS(null, 'data-velocity', Number(element.getAttributeNS(null, 'data-velocity')) * dragMultiplier);
        if (element.getAttributeNS(null, 'cx') > vaguely(config.width, Math.random() * 200)) {
            element.remove();
        }
    });
}
function giveBirth(count) {
    for (var i = 0; i < count; i++) {
        createSvgCircle(
            vaguely(config.emitterCentre[0], emitterRadius), 
            vaguely(config.emitterCentre[1], emitterRadius), 
            vaguely(particleSize, particleSizeRandom),
            // 'rgba(0,0,0,' + Math.random().toFixed(2) + ')',
            // 'url(#cloud)',
            // '#FD797970',
            '#CE1D2870', 
            null, 
            particlesParent);
    }

}
window.doAnimation = function () {
    applyGravity(gravitySpeed,  gravityDirection);
    applyVelocity();
    var _particles = Math.round(Math.random() * particlesPerCycle)
    giveBirth(_particles);
    // console.log('running')
    // particlePlay = 
    requestAnimationFrame(doAnimation);
}
// particlePlay = requestAnimationFrame(doAnimation);
// requestAnimationFrame(doAnimation)



// function doSetup(){
// config.height = window.innerHeight;
// config.width = document.querySelector('div + div').clientWidth;
// config.viewHeight = config.height * 10;
// config.viewWidth = config.width * 10;
// s.style.height = config.height + 'px';
// s.style.width = config.width + 'px';
// s.setAttribute('viewBox', '0 0 ' + config.viewWidth + ' ' + config.viewHeight);
// config.emitterCentre = [config.viewWidth/2, config.viewHeight/2];
// }

// function createSvgCircle(cx, cy, r, fill, stroke, parent){
// var c = document.createElementNS(svgNS, 'circle');
// c.setAttributeNS(null, 'r', Math.max(0, r));
// c.setAttributeNS(null, 'cx', cx);
// c.setAttributeNS(null, 'cy', cy);
// c.setAttributeNS(null, 'fill', fill);
// c.setAttributeNS(null, 'data-velocity', vaguely(document.querySelector('#velocity').value, document.querySelector('#velocityRandom').value));
// c.setAttributeNS(null, 'data-direction', vaguely(document.querySelector('#emitterDirection').value, document.querySelector('#emitterDirectionRandom').value));
// if(stroke){
//     c.setAttributeNS(null, 'stroke', stroke);
// }
// parent.appendChild(c);
// }

// function applyVelocity() {
//     var _particles = Array.prototype.slice.call(document.querySelectorAll('circle'));
//     _particles.forEach(function (element, index, array) {
//         var _vector = calculateVector(element.getAttributeNS(null, 'data-velocity'), element.getAttributeNS(null, 'data-direction'));
//         var startCx = Number(element.getAttributeNS(null, 'cx'));
//         var startCy = Number(element.getAttributeNS(null, 'cy'));
//         var endCx = startCx + _vector[0];
//         var endCy = startCy + _vector[1];
//         element.setAttributeNS(null, 'cx', endCx);
//         element.setAttributeNS(null, 'cy', endCy);
//         element.setAttributeNS(null, 'data-velocity', Number(element.getAttributeNS(null, 'data-velocity')) * Number(document.querySelector('#drag').value));
//         if (element.getAttributeNS(null, 'cx') > config.viewHeight) {
//             element.remove();
//         }
//     });
//     document.querySelector('#count').innerText = _particles.length + ' particles'
// }
// function giveBirth(count) {
//     for (var i = 0; i < count; i++) {
//         createSvgCircle(
//             vaguely(config.emitterCentre[0], document.querySelector('#emitterRadius').value), 
//             vaguely(config.emitterCentre[1], document.querySelector('#emitterRadius').value), 
//             vaguely(document.querySelector('#particleSize').value, document.querySelector('#particleSizeRandom').value),
//         // 'rgba(0,0,0,' + Math.random().toFixed(2) + ')',
//         // 'url(#cloud)',
//             '#FD797970', null, s);
//     }
// }
// window.doAnimation = function () {
//     applyGravity(document.querySelector('#gravitySpeed').value, document.querySelector('#gravityDirection').value);
//     applyVelocity();
//     var _particles = Math.round(Math.random() * document.querySelector('#maxParticles').value)
//     giveBirth(_particles);
//     particlePlay = requestAnimationFrame(doAnimation);
// }


// document.querySelector('#start').addEventListener('click', function (event) {
//     particlePlay = requestAnimationFrame(doAnimation);
//     event.target.disabled = 'disabled';
//     document.querySelector('#stop').removeAttribute('disabled');
// });
// document.querySelector('#stop').addEventListener('click', function (event) {
//     cancelAnimationFrame(particlePlay);
//     event.target.disabled = 'disabled';
//     document.querySelector('#start').removeAttribute('disabled');
// });
// window.addEventListener('resize', function () {
//     console.log('resize');
//     doSetup();
// });
